import { useMutation, useQuery } from "@tanstack/react-query";
import { emailProgramService } from "../../services/emailProgram.service";

export const useEmailPrograms = () =>
	useQuery({
		queryKey: ["sims-email-programs"],
		queryFn: () => emailProgramService.listEmailPrograms(),
		staleTime: 1000 * 60 * 5,
	});

/**
 * The rendered email for one account.
 *
 * 🔴 `brandingAccountId` is IN THE KEY, and has to stay there. It is an input to
 * the query function, so leaving it out would serve the previously selected
 * account's document from cache while the selector showed a different name —
 * the failure would look like "branding does not apply", which is exactly the
 * thing this page exists to disprove.
 */
export const useEmailProgramPreview = (
	key: string,
	brandingAccountId: string,
	enabled: boolean,
) =>
	useQuery({
		queryKey: ["sims-email-program-preview", key, brandingAccountId],
		queryFn: () =>
			emailProgramService.previewEmailProgram(key, brandingAccountId),
		enabled: enabled && !!key && !!brandingAccountId,
	});

export const useSendTestEmail = () =>
	useMutation({
		mutationFn: ({
			key,
			email,
			brandingAccountId,
		}: {
			key: string;
			email: string;
			brandingAccountId?: string;
		}) => emailProgramService.sendTestEmail(key, email, brandingAccountId),
	});
